import { AutocompleteElement } from "@nosto/search-js/preact/autocomplete"
import type { Product } from "@/types"
import { ProductCardContent } from "@/components/Product/Product"
import styles from "@/components/Product/Product.module.css"

type Props = {
  hit: Product
}

/**
 * Renders an autocomplete product result, sharing the same card markup as the SERP/category product card.
 * Keep the AutocompleteElement wrapper in place so Nosto search analytics can track product clicks.
 */
export default function Product({ hit }: Props) {
  return (
    <AutocompleteElement
      key={hit.productId}
      hit={{
        productId: hit.productId!,
        url: hit.url
      }}
      as="a"
      componentProps={{
        "aria-label": `Product ${hit.name}`,
        className: styles.nsCard,
        href: hit.url
      }}
    >
      <ProductCardContent product={hit} />
    </AutocompleteElement>
  )
}
